import React from "react";
import firebase from "firebase";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import Dropzone from "react-dropzone";
import ImageCompressor from "image-compressor.js";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Layout from "../layouts/Layout";
import { primaryShade1, white } from "../styles/color";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import PropTypes from "prop-types";
import WarningIcon from "@material-ui/icons/Warning";
import CircularProgress from "@material-ui/core/CircularProgress";
import Img from "react-image";
import ExifOrientationImg from "react-exif-orientation-img";
//import Img from "react-fix-image-orientation";
import loadImage from "blueimp-load-image";
import AddAPhoto from "@material-ui/icons/AddAPhoto";
import ImageAddCircleOutline from "@material-ui/icons/Edit";
import "../styles/uploadImage.css";
let platform = "other";

if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

const variantIcon = {
  warning: WarningIcon
};
const stylesSnackbar = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(stylesSnackbar)(MySnackbarContent);
const styles = {
  bigAvatar: {
    height: "150px",
    width: "150px",
    margin: 15
  }
};
const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
class UpdateInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      imageURL: "",
      phoneNumber: "",
      panNo: "",
      address: "",
      organisationName: "",
      organisationId: "",
      date: moment(new Date()).format("YYYY-MM-DD"),
      openSnackBar: false,
      snackbarMessage: ""
    };
  }

  // getIcon = (acceptedFiles, rejectedFiles) => {
  //   const file = null;
  //   if (platform === "ios") {
  //     const loadImageOptions = { canvas: true };
  //     loadImage.parseMetaData(acceptedFiles[0], data => {
  //       if (data.exif && data.exif.get("Orientation")) {
  //         loadImageOptions.orientation = data.exif.get("Orientation");
  //       }
  //       loadImage(
  //         acceptedFiles[0],
  //         canvas => {
  //           acceptedFiles[0].preview = canvas.toDataURL(acceptedFiles[0].type);
  //           file = acceptedFiles[0];
  //         },
  //         loadImageOptions
  //       );
  //     });
  //   } else {
  //     file = acceptedFiles[0];
  //   }
  //   if (file == null) {
  //     alert("Invalid File Type!");
  //   } else {
  //     this.setState({
  //       completed1: true,
  //       isLoadingUploadImage: 2,
  //       imageURL: null
  //     });
  //   }

  //   new ImageCompressor(file, {
  //     quality: 0.55,
  //     maxWidth: 1500,
  //     success: result => {
  //       const image = firebase
  //         .storage()
  //         .ref()
  //         .child("images");
  //       const ref = image.child(new Date().toString());
  //       ref.put(file).then(() => {
  //         ref.getDownloadURL().then(url => {
  //           console.log(url);
  //           const updatedImageURL = url;
  //           console.log(updatedImageURL);
  //           const pictures = this.state.pictures;
  //           // pictures.push(url);
  //           this.setState({
  //             completed: true,
  //             pictures,
  //             imageURL: updatedImageURL,
  //             isLoadingUploadImage: 3
  //           });
  //           console.log(updatedImageURL);
  //         });
  //       });
  //     }
  //   });
  // };
  getIcon = (acceptedFiles, rejectedFiles) => {
    if (platform === "ios") {
      const file = null;
      const loadImageOptions = { canvas: true };
      loadImage.parseMetaData(acceptedFiles[0], data => {
        if (data.exif && data.exif.get("Orientation")) {
          loadImageOptions.orientation = data.exif.get("Orientation");
        }
        loadImage(
          acceptedFiles[0],
          canvas => {
            acceptedFiles[0].preview = canvas.toDataURL(acceptedFiles[0].type);
            // file = acceptedFiles[0];
            new ImageCompressor(acceptedFiles[0], {
              quality: 0.55,
              maxWidth: 1500,
              success: result => {
                const image = firebase
                  .storage()
                  .ref()
                  .child("images");
                const ref = image.child(new Date().toString());
                ref.put(acceptedFiles[0]).then(() => {
                  ref.getDownloadURL().then(url => {
                    const updatedImageURL = url;
                    const pictures = this.state.pictures;
                    // pictures.push(url);
                    this.setState({
                      completed: true,
                      pictures,
                      imageURL: updatedImageURL,
                      isLoadingUploadImage: 3
                    });
                  });
                });
              }
            });
          },
          loadImageOptions
        );
      });
    } else {
      const file = acceptedFiles[0];

      if (file == null) {
        alert("Invalid File Type!");
      } else {
        this.setState({
          completed1: true,
          isLoadingUploadImage: 2,
          imageURL: null
        });
      }
      new ImageCompressor(file, {
        quality: 0.55,
        maxWidth: 1500,
        success: result => {
          const image = firebase
            .storage()
            .ref()
            .child("images");
          const ref = image.child(new Date().toString());
          ref.put(file).then(() => {
            ref.getDownloadURL().then(url => {
              const updatedImageURL = url;
              const pictures = this.state.pictures;
              // pictures.push(url);
              this.setState({
                completed: true,
                pictures,
                imageURL: updatedImageURL,
                isLoadingUploadImage: 3
              });
            });
          });
        }
      });
    }
  };
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData(whichProps) {
    this.setState({
      name: whichProps.currentUser[0].name,
      email: whichProps.currentUser[0].email,
      imageURL: whichProps.currentUser[0].imageURL
    });
    if (whichProps.currentUser[0].phoneNumber) {
      this.setState({ phoneNumber: whichProps.currentUser[0].phoneNumber });
    } else {
      this.setState({ phoneNumber: null });
    }
    if (whichProps.currentUser[0].panNumber) {
      this.setState({ panNo: whichProps.currentUser[0].panNumber });
    } else {
      this.setState({ panNo: null });
    }
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationName: whichProps.organisations.organisationName,
        organisationId: whichProps.organisations.organisationId
      });
    }
  }
  handleChange = name => event => {
    if (name === "panNo") {
      this.setState({ panNo: event.target.value.toUpperCase() });
    } else {
      this.setState({ [name]: event.target.value });
    }
  };
  handleOpenSnackBar = snackbarMessage => {
    this.setState({ openSnackBar: true, snackbarMessage: snackbarMessage });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };
  render() {
    const {
      updateUserInfo,
      currentUser,
      classes,
      updateOrganisation,
      addOrganisation
    } = this.props;
    const {
      name,
      email,
      phoneNumber,
      imageURL,
      organisationName,
      organisationId,
      snackbarMessage,
      panNo,
      date
    } = this.state;
    return currentUser.length > 0 ? (
      <Layout
        position="static"
        appBar
        appBarTitle={"UPDATE INFO"}
        bottomNavigation={false}
        selectedValue={2}
        appBarLeftIcon={true}
      >
        <div
          style={{
            marginTop: "75px",
            height: "100%",
            maxHeight: "76%",
            overflow: "scroll"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItem: "center",
              margin: "10px",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
              onClick={this.onDrop}
            >
              <Dropzone onDrop={this.getIcon} accept="image/*">
                {({ getRootProps, getInputProps, isDragActive }) => {
                  return (
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <u>
                        {!imageURL ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                              height: "140px",
                              width: "140px",
                              margin: "10px"
                            }}
                          >
                            <AddAPhoto
                              style={{
                                color: primaryShade1,
                                height: "140px",
                                width: "140px"
                              }}
                            />
                          </div>
                        ) : platform === "ios" ? (
                          <div
                            className="imgContainer"
                            style={{
                              display: "flex",
                              flexFlow: "wrap-reverse"
                            }}
                          >
                            <Img
                              src={imageURL}
                              alt={name.charAt(0).toUpperCase()}
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                height: "140px",
                                width: "140px",
                                objectFit: "cover",
                                borderRadius: "50%"
                              }}
                              loader={
                                <CircularProgress
                                  style={{ height: "100px", width: "100px" }}
                                />
                              }
                            />
                            <div className="overlayImageEditIcon">
                              <ImageAddCircleOutline />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="imgContainer"
                            style={{
                              display: "flex",
                              flexFlow: "wrap-reverse"
                            }}
                          >
                            <ExifOrientationImg
                              src={imageURL}
                              alt={name.charAt(0).toUpperCase()}
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",

                                height: "140px",
                                width: "140px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                imageOrientation: `from-image`
                              }}
                              loader={
                                <CircularProgress
                                  style={{ height: "100px", width: "100px" }}
                                />
                              }
                            />
                            <div className="overlayImageEditIcon">
                              <ImageAddCircleOutline />
                            </div>
                          </div>
                        )}
                      </u>
                    </div>
                  );
                }}
              </Dropzone>
            </div>

            <TextField
              id="outlined-bare"
              type="text"
              value={name}
              required={true}
              onChange={this.handleChange("name")}
              margin="normal"
              variant="outlined"
              className={classNames(classes.margin)}
              label="Name"
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="outlined-bare"
              name="phoneNumber"
              placeholder="9876543210"
              type="number"
              onChange={this.handleChange("phoneNumber")}
              value={phoneNumber}
              margin="normal"
              variant="outlined"
              className={classNames(classes.margin)}
              label="Phone Number"
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="outlined-bare"
              name="email"
              placeholder="xyz@example.com"
              type="email"
              onChange={this.handleChange("email")}
              value={email}
              margin="normal"
              variant="outlined"
              className={classNames(classes.margin)}
              label="Email"
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="outlined-bare"
              type="text"
              value={panNo}
              required={true}
              inputProps={{
                autoCapitalize: true
              }}
              onChange={this.handleChange("panNo")}
              margin="normal"
              variant="outlined"
              className={classNames(classes.margin)}
              label="Pan Number"
              InputLabelProps={{
                shrink: true
              }}
            />
            <TextField
              id="outlined-bare"
              name="organisationName"
              placeholder=" "
              type="text"
              required={true}
              onChange={this.handleChange("organisationName")}
              value={organisationName}
              margin="normal"
              variant="outlined"
              className={classNames(classes.margin)}
              label="Organisation Name"
              InputLabelProps={{
                shrink: true
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            position: platform === "ios" ? "absolute" : "fixed",
            bottom: "10px",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            onClick={e => {
              e.preventDefault();
              if (organisationName !== "" && name !== "") {
                updateUserInfo(
                  this.state.name,
                  this.state.email,
                  this.state.imageURL,
                  this.state.phoneNumber,
                  this.state.panNo,
                  organisationId
                );
                if (organisationId !== "") {
                  updateOrganisation(organisationId, organisationName);
                } else {
                  const organisation = {
                    organisationName: organisationName,
                    createdBy: this.props.user.uid,
                    createdAt: new Date()
                  };
                  addOrganisation(organisation);
                }
                this.props.history.goBack();
              } else {
                this.handleOpenSnackBar(
                  "All Fields Marked With * Sign Must Be Filled!...."
                );
              }
            }}
            style={{
              display: "flex",
              backgroundColor: primaryShade1,
              color: white
            }}
          >
            UPDATE
          </Button>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            open={this.state.openSnackBar}
            autoHideDuration={3000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClick={this.handleClose}
              variant="warning"
              message={snackbarMessage}
            />
          </Snackbar>
        </div>
      </Layout>
    ) : (
      "wait....."
    );
  }
}

export default withRouter(withUser(withStyles(stylesMain)(UpdateInfo)));
